import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { SITE } from "@/config";
import Header from "@/components/landing/Header";
import Hero from "@/components/page/Hero";
import Idea from "@/components/page/Idea";
import HowTo from "@/components/page/HowTo";
import Inclusions from "@/components/page/Inclusions";
import Doctor from "@/components/page/Doctor";
import Features from "@/components/page/Features";
import Offer from "@/components/page/Offer";
import Faq from "@/components/page/Faq";
import Contact from "@/components/page/Contact";
import Footer from "@/components/landing/Footer";
import StickyBar from "@/components/landing/StickyBar";

function App() {
  useEffect(() => {
    document.title = `${SITE.brand} — ${SITE.kitName} | ${SITE.price}`;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain bg-ivory pb-[76px] md:pb-0">
      <Header />
      <main>
        <Hero />
        <Inclusions />
        <Idea />
        <HowTo />
        <Doctor />
        <Features />
        <Offer />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}

export default App;
